var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.32,913.57,340.14,699.83l73.32-78,32-34.1,8-8.53,4-4.26,2-2.13.5-.53c.17-.13.33-.53.51-.2l1,1,16.58,16.51,66.32,66,71.92,71.59,49.91,49.69,12.48,12.42,3.12,3.11,1.56,1.55c.12.08.29.38.37.27l.24-.31.49-.61,3.9-4.87L704,769,892.77,533.24l104.85,83.94,37.51-246.06L1061,201.19,900.9,263.65,669,354.09l104.85,84L680.44,554.73l-7.31,9.13-1.83,2.28-.23.29-.11.14s0,0,0,0l-.06-.06-.13-.13-.51-.51-2.05-2-32-31.85L494.65,391.1l-35.39-35.22-2.21-2.21-.27-.27c-.1-.18-.18.07-.27.12l-.54.57-1.07,1.14-4.27,4.54-8.55,9.1L425,387.06l-68.37,72.77L229.13,595.53,28.31,809.27Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.d2ad252d4b6215746935e31ab4378ebf.svg";
export { ForwardRef as ReactComponent };